import { useTranslations } from 'next-intl'

import { Logout } from '@/components/Icons'
import { LanguageSelector } from '@/features/Footer/LanguageSelector'
import { LoginButton } from '@/features/header/LoginButton'
import { setOverlayView } from '@/features/overlay/overlaySlice'
import { LOGIN_STATUS } from '@/features/user/userSlice'
import { useAppDispatch } from '@/utils/useAppDispatch'
import { useAppSelector } from '@/utils/useAppSelector'

import styles from './Actions.module.scss'

interface Props {
  closeMenu: () => void
}

const Actions = ({ closeMenu }: Props) => {
  const t = useTranslations()
  const isLoggedIn = useAppSelector((state) => state.user.loginStatus === LOGIN_STATUS.LOGGED_IN)
  const dispatch = useAppDispatch()

  return (
    <div className={styles.Actions}>
      {!isLoggedIn && <LoginButton additionalClasses={styles.LoginButton} onClick={closeMenu} />}
      <LanguageSelector id="menu-language-selector" isMobileNav />
      {isLoggedIn && (
        <button
          className={styles.LogoutButton}
          onClick={() => {
            dispatch(setOverlayView({ view: { type: 'LOGOUT' } }))
          }}
        >
          <Logout />
          <span>{t('logout')}</span>
        </button>
      )}
    </div>
  )
}

export default Actions
